module.exports = __webpack_public_path__ + "static/media/brand-icons.c5ebe0b3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/brand-icons.ttf
// module id = ./src/styling/theme/assets/fonts/brand-icons.ttf
// module chunks = 0